module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service) ? _c('article', {
    staticClass: "tile is-child box"
  }, [(parseInt(_vm.$store.state.config.user.level) < 99) ? [(_vm.service.changes || _vm.service.change) ? _c('div', {
    staticClass: "notification is-warning"
  }, [(parseInt(_vm.service.changed) == 1 || parseInt(_vm.service.changed) == 2) ? [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    staticStyle: {
      "font-size": "20px"
    }
  }), _vm._v(" This is the (ORIGINAL) booking of a SAVE. "), _c('a', {
    attrs: {
      "href": _vm.url(_vm.service.changes.newservice.id),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.service.changes.newservice.booking_id) + "-" + _vm._s(_vm.service.changes.newservice.service_id))])] : [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    staticStyle: {
      "font-size": "20px"
    }
  }), _vm._v(" This is the (SAVE) booking of the ORIGINAL. "), _c('a', {
    attrs: {
      "href": _vm.url(_vm.service.change.oldservice.id),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.service.change.oldservice.booking_id) + "-" + _vm._s(_vm.service.change.oldservice.service_id))])]], 2) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.related.length > 1) ? _c('div', {
    staticClass: "notification is-info"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    }
  }), _vm._v(" Related services:\n    "), _vm._l((_vm.related), function(related_service) {
    return [(related_service.id != _vm.service.id) ? _c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": _vm.url(related_service.id),
        "target": "_self"
      }
    }, [_vm._v(_vm._s(parseInt(_vm.service.integration) === 1 ? related_service.service_id : related_service.api_service_id))]) : _vm._e(), _vm._v(" \n    ")]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('a', {
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        return _vm.newOccurrence()
      }
    }
  }, [_c('span', [_vm._v("New Ticket")])])]), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? [(parseInt(_vm.service.integration) <= 2) ? [_c('div', {
    staticClass: "column is-10"
  }, [_c('h4', {
    staticClass: "title",
    staticStyle: {
      "border": "none"
    }
  }, [_c('span', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(parseInt(_vm.service.integration) === 1 ? 'Cangooroo: ' + _vm.service.booking_id + '-' + _vm.service.service_id : 'EZ Connect: ' + _vm.service.api_booking_id + '-' + _vm.service.api_service_id) + " (" + _vm._s(_vm.service.status) + ") " + _vm._s(parseInt(_vm.service.integration) === 2 ? '/ ' + _vm.service.our_status : ''))])])])] : [_c('div', {
    staticClass: "column is-10"
  }, [_c('h4', {
    staticClass: "title",
    staticStyle: {
      "border": "none"
    }
  }, [_c('span', {
    staticClass: "is-pulled-right"
  }, [_vm._v("Manual Service - " + _vm._s(_vm.service.id) + " (" + _vm._s(_vm.service.status) + ") ")])])])]] : [_c('div', {
    staticClass: "column is-10"
  }, [_c('h4', {
    staticClass: "title",
    staticStyle: {
      "border": "none"
    }
  }, [_c('span', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(parseInt(_vm.service.integration) === 1 ? 'Cangooroo: ' + _vm.service.booking_id + '-' + _vm.service.service_id : 'EZ Connect: ' + _vm.service.api_booking_id + '-' + _vm.service.api_service_id) + " (" + _vm._s(_vm.service.status) + ") ")])])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h4', {
    staticClass: "title",
    staticStyle: {
      "border": "none"
    }
  }, [_c('span', {
    staticClass: "is-pulled-right"
  }, [_vm._v("Team User: " + _vm._s(_vm.service.user !== null ? _vm.service.user.name : 'Not Allocated'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("Hotel\n          "), ((parseInt(_vm.$store.state.config.user.level) < 99)) ? _c('tooltip', {
    attrs: {
      "label": "Refresh Service",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.refreshService()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-bed"
  }), _vm._v("\n          " + _vm._s(_vm.service.room.hotel.name + (parseInt(_vm.$store.state.config.user.level) < 99 ? (_vm.service.room.hotel.chain_hotel ? ' (' + _vm.service.room.hotel.chain_hotel.chain.name + ')' : '') : '')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("\n          " + _vm._s(_vm.service.room.description.substring(0, 45)) + "\n          "), (_vm.service.room.description.length > 45) ? [_c('tooltip', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "label": _vm.service.room.description,
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])])] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v("\n          " + _vm._s(_vm.service.room.board_description) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.service.service_date, 'YYYY-MM-DD')))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.service.service_date, 'add', _vm.service.room.number_nights + ' days', 'YYYY-MM-DD')))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.service.paxes.length) + "\n        ")]), _vm._v(" "), (parseInt(_vm.service.integration) === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v("\n          Adults: "), _c('b', [_vm._v(_vm._s(_vm.service.room.number_adults))]), _vm._v(" Children: "), _c('b', [_vm._v(_vm._s(_vm.service.room.number_children))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-moon-o"
  }), _vm._v("\n          " + _vm._s(_vm.service.room.number_nights) + "\n        ")]), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 4) ? [_c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v("\n            Client: "), _c('b', [_vm._v(_vm._s(this.salePrice()))]), _vm._v(" Provider: "), _c('b', [_vm._v(_vm._s(_vm.service.room.provider_price) + " " + _vm._s(_vm.service.room.provider_currency))])])] : [_c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v("\n            " + _vm._s(_vm.service.price + " " + _vm.service.currency) + "\n          ")])], _vm._v(" "), _c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Hotel Info")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.service.room.hotel.city.name))]), _vm._v(" - "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(" + _vm._s(_vm.service.room.hotel.location) + ")")])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("\n          " + _vm._s(_vm.service.room.hotel.address) + "\n        ")]), _vm._v(" "), (_vm.service.room.hotel_info.phone) ? _vm._l((_vm.service.room.hotel_info.phone.split(',')), function(phone) {
    return _c('p', {
      staticClass: "panel-block",
      attrs: {
        "value": 'phone' + phone
      }
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'tel:' + phone.replaceAll(',', '')
      }
    }, [_vm._v(_vm._s(phone.replaceAll(',', '')))])])
  }) : _vm._e(), _vm._v(" "), (_vm.service.room.hotel_info.email) ? [_c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.service.room.hotel_info.email
    }
  }, [_vm._v(_vm._s(_vm.service.room.hotel_info.email))])])] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success"
  }, [_vm._v("Paxs")]), _vm._v(" "), _vm._l((_vm.service.paxes), function(pax) {
    return _c('p', {
      staticClass: "panel-block"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" "), (parseInt(_vm.service.integration) === 1) ? [_vm._v("\n          " + _vm._s(pax.title) + " . " + _vm._s(pax.name) + " " + _vm._s(pax.last_name) + " - AGE: " + _vm._s(pax.age) + "\n          ")] : [_vm._v("\n            " + _vm._s(pax.name) + " " + _vm._s(pax.last_name)), (pax.age > 0) ? _c('span', [_vm._v(" - AGE: " + _vm._s(pax.age))]) : _vm._e()]], 2)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Cancellation")]), _vm._v(" "), (_vm.service.refundable !== null) ? [_c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('b', [_vm._v("Refundable: ")]), _vm._v(" " + _vm._s(_vm.service.refundable ? 'True' : 'False') + "\n          ")])] : _vm._e(), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? [_vm._l((_vm.service.cancellations), function(cancellation) {
    return _c('p', {
      staticClass: "panel-block"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" "), _c('b', [_vm._v("From: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(cancellation.start_date, 'YYYY-MM-DD hh:mm A')) + "\n            "), _c('b', [_vm._v("To: ")]), _vm._v(_vm._s(_vm._f("moment")(cancellation.end_date, 'YYYY-MM-DD hh:mm A')) + "\n            "), _c('b', [_vm._v("Value: "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(parseFloat(cancellation.price).toFixed(2)) + " " + _vm._s(cancellation.currency))])]), _vm._v(" -\n            "), _c('b', [_vm._v(_vm._s(parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'))])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.service.status === 'Cancelled'),
      expression: "service.status === 'Cancelled'"
    }],
    staticClass: "panel-block"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('b', [_vm._v("Cancelled:")]), _vm._v(" " + _vm._s(_vm.service.cancellation_date) + "\n            ")])])] : _vm._l((_vm.service.cancellations), function(cancellation) {
    return (parseInt(cancellation.type) === 2) ? _c('p', {
      staticClass: "panel-block"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" "), _c('b', [_vm._v("From: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(cancellation.start_date, 'YYYY-MM-DD hh:mm A')) + "\n            "), _c('b', [_vm._v("To: ")]), _vm._v(_vm._s(_vm._f("moment")(cancellation.end_date, 'YYYY-MM-DD hh:mm A')) + "\n            "), _c('b', [_vm._v("Value: "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(parseFloat(cancellation.price).toFixed(2)) + " " + _vm._s(cancellation.currency))])]), _vm._v(" -\n            "), _c('b', [_vm._v(_vm._s(parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'))])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [(parseInt(_vm.$store.state.config.user.level) < 4) ? [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "panel panel-warning"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-warning"
  }, [_vm._v("Broker Info")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_vm._v("\n              " + _vm._s(_vm.service.room.provider.name) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  }), _vm._v(" "), (parseInt(_vm.service.integration) <= 2) ? [_vm._v("\n                " + _vm._s(parseInt(_vm.service.integration) === 1 ? _vm.service.room.provider_booking_code : (_vm.service.api_supplier_id !== _vm.service.room.provider_booking_code ? _vm.service.api_supplier_id + (_vm.service.room.provider_booking_code !== null ? '-' + _vm.service.room.provider_booking_code : '') : _vm.service.api_supplier_id)) + "\n              ")] : [_vm._v("\n                  " + _vm._s(_vm.service.room.provider_booking_code) + "\n                ")]], 2), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n              " + _vm._s(_vm.service.reservation_date) + "\n            ")])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "panel panel-warning"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-warning"
  }, [_vm._v("Customer Info")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_vm._v("Agency: "), _c('b', [_vm._v(_vm._s(_vm.service.agency.name))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_vm._v("Client Ref:\n            "), (_vm.service.agency.id === 25) ? _c('a', {
    attrs: {
      "href": _vm.url(_vm.booking),
      "target": "_blank"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.service.client_ref))])]) : _vm._e(), _vm._v(" "), (_vm.service.agency.id !== 25) ? _c('b', [_vm._v(_vm._s(_vm.service.client_ref))]) : _vm._e()])])])], 2), _vm._v(" "), ((parseInt(_vm.$store.state.config.user.level) < 4)) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.service.invoice || _vm.service.payment_order),
      expression: "service.invoice || service.payment_order"
    }],
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-card"
  }, [_vm._v("Finances")]), _vm._v(" "), (parseInt(_vm.service.card_payment) === 1 && _vm.service.invoice) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('b', [_vm._v("Card:")]), _vm._v(" XXXX XXXX XXXX " + _vm._s(_vm.service.card_client.last4) + " - " + _vm._s(_vm.service.card_client.brand.toUpperCase()) + " "), _c('b', [_vm._v("Gateway:")]), _vm._v(" " + _vm._s(_vm.service.card_client.type === 1 ? 'Stripe' : 'WorldPay')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Value:")]), _vm._v(" " + _vm._s(_vm.service.card_client.value) + " " + _vm._s(_vm.service.card_client.currency) + " "), _c('b', [_vm._v("Installment:")]), _vm._v(" " + _vm._s(_vm.service.card_client.installment) + "X\n      ")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.service.card_payment) === 0 && _vm.service.invoice != null && ((_vm.service.status == 'Confirmed') || (_vm.service.status === 'PendingCancellation') || ((_vm.service.status === 'Cancelled') && ((new Date(_vm.service.service_date)).getTime() <= (new Date(_vm.service.cancellation_date).getTime()))) || parseInt(_vm.service.dispute) == 1 || parseInt(_vm.service.invoice.protected) == 1)) ? _c('p', {
    staticClass: "panel-block"
  }, [(parseInt(_vm.service.invoice.invoice.payment) != 1) ? [_c('tooltip', {
    attrs: {
      "label": parseInt(_vm.service.invoice.protected) == 0 ? 'Protect' : 'Unprotect',
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.protectInvoice()
      }
    }
  }, [_c('i', {
    class: {
      'fa': true,
      'fa-lock': parseInt(_vm.service.invoice.protected) == 0,
      'fa-unlock': parseInt(_vm.service.invoice.protected) == 1
    }
  })])])] : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Invoice:")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openInvoice(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.service.invoice.invoice_id))]), (parseInt(_vm.service.invoice.invoice.payment) == 1) ? _c('label', [_c('b', [_vm._v("(Payed)")]), _vm._v(" - " + _vm._s(_vm._f("moment")(_vm.service.invoice.invoice.deposit_date, 'YYYY-MM-DD')))]) : _vm._e(), _vm._v(" "), (_vm.service.invoice.invoice.payment) ? _c('label', [_c('b', [_vm._v("(" + _vm._s(_vm.parsePreMethod(_vm.service.invoice.invoice.payment)) + ")")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.service.payment_order != null && parseInt(_vm.service.payment_order.payment.payment_method_id) !== 36 && ((_vm.service.status == 'Confirmed') || (_vm.service.status === 'PendingCancellation') || (_vm.service.status === 'Cancelled') && ((new Date(_vm.service.service_date)).getTime() < (new Date(_vm.service.cancellation_date).getTime())) || parseInt(_vm.service.dispute) == 1 || parseInt(_vm.service.payment_order.protected) == 1)) ? _c('p', {
    staticClass: "panel-block"
  }, [(parseInt(_vm.service.payment_order.payment.payment) != 1) ? [_c('tooltip', {
    attrs: {
      "label": parseInt(_vm.service.payment_order.protected) == 0 ? 'Protect' : 'Unprotect',
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.protectPayment()
      }
    }
  }, [_c('i', {
    class: {
      'fa': true,
      'fa-lock': parseInt(_vm.service.payment_order.protected) == 0,
      'fa-unlock': parseInt(_vm.service.payment_order.protected) == 1
    }
  })])])] : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Payment:")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openPayment()
      }
    }
  }, [_vm._v(_vm._s(_vm.service.payment_order.payment_id))]), (parseInt(_vm.service.payment_order.payment.payment) == 1) ? _c('label', [_c('b', [_vm._v("(Payed)")]), _vm._v(" - " + _vm._s(_vm._f("moment")(_vm.service.payment_order.payment.deposit_date, 'YYYY-MM-DD')))]) : _vm._e(), _vm._v(" "), (_vm.service.payment_order.payment) ? _c('label', [_c('b', [_vm._v("(" + _vm._s(_vm.parsePreMethod(_vm.service.payment_order.payment.payment)) + ")")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (parseInt(_vm.service.payment_type) === 'credit card') ? _c('p', {
    staticClass: "panel-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.service.payment_last4))]), _c('label', [_vm._v(_vm._s(_vm.service.payment_description))])]) : _vm._e(), _vm._v(" "), (_vm.service.card) ? [(_vm.service.payment_type === 'credit card' && !_vm.newCard && _vm.service.payment_order) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('b', [_vm._v("Card: ")]), _c('label', [_vm._v(_vm._s(_vm.service.payment_description) + " - "), _c('b', [_vm._v("Main:")]), _vm._v(" #" + _vm._s(_vm.service.card.id) + " - " + _vm._s(_vm.service.card.brand) + " - " + _vm._s(_vm.service.card.card) + " - " + _vm._s(_vm.service.card.bank))])]) : _vm._e()] : [(_vm.service.payment_type === 'credit card' && !_vm.newCard && _vm.service.payment_order) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('b', [_vm._v("Card: ")]), _c('label', [_vm._v(_vm._s(_vm.service.payment_description))])]) : _vm._e()]], 2), _vm._v(" "), ((_vm.service.payment_services_v2 || _vm.service.invoice_services_v2)) ? _c('finances', {
    attrs: {
      "service": _vm.service
    }
  }) : _vm._e()] : [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.service.invoice || _vm.service.payment_order),
      expression: "service.invoice || service.payment_order"
    }],
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Finances")]), _vm._v(" "), (parseInt(_vm.service.card_payment) === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('b', [_vm._v("Card:")]), _vm._v(" XXXX XXXX XXXX " + _vm._s(_vm.service.card[0].last4) + " - " + _vm._s(_vm.service.card[0].brand.toUpperCase()) + " "), _c('b', [_vm._v("Gateway:")]), _vm._v(" " + _vm._s(_vm.service.card[0].type === 1 ? 'Stripe' : 'WorldPay')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Value:")]), _vm._v(" " + _vm._s(_vm.service.card[0].value) + " " + _vm._s(_vm.service.card[0].currency) + " "), _c('b', [_vm._v("Installment:")]), _vm._v(" " + _vm._s(_vm.service.card[0].installment) + "X\n      ")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.service.card_payment) === 0 && _vm.service.invoice != null && ((_vm.service.status == 'Confirmed') || (_vm.service.status === 'PendingCancellation') || ((_vm.service.status === 'Cancelled') && ((new Date(_vm.service.service_date)).getTime() <= (new Date(_vm.service.cancellation_date).getTime()))) || parseInt(_vm.service.dispute) == 1 || parseInt(_vm.service.invoice.protected) == 1)) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('b', [_vm._v("Invoice:")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openInvoice(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.service.invoice.invoice_id))]), _vm._v(" "), (parseInt(_vm.service.invoice.invoice.payment) == 1) ? _c('label', [_c('b', [_vm._v("(Payed)")]), _vm._v(" - " + _vm._s(_vm._f("moment")(_vm.service.invoice.invoice.deposit_date, 'YYYY-MM-DD')))]) : _vm._e(), _vm._v(" "), (_vm.service.invoice.invoice.payment) ? _c('label', [_c('b', [_vm._v("(" + _vm._s(_vm.parsePreMethod(_vm.service.invoice.invoice.payment)) + ")")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), ((_vm.service.invoice_services_v2)) ? _c('finances', {
    attrs: {
      "service": _vm.service
    }
  }) : _vm._e()], _vm._v(" "), (_vm.service.observation && _vm.service.observation !== '') ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Observation")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.service.observation)
    }
  })])])])])] : _vm._e(), _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 4 && _vm.service.remarks && _vm.service.remarks !== '') ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.service.remarks)
    }
  })])])])])] : _vm._e(), _vm._v(" "), (parseInt(_vm.service.internal_status) == 3 || (_vm.service.confirmation_datetime !== null && parseInt(_vm.service.internal_status) < 4)) ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success"
  }, [_vm._v("Reconfirmation "), ((parseInt(_vm.$store.state.config.user.level) < 4)) ? _c('a', {
    staticClass: "button is-primary is-small",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.reconfirmation()
      }
    }
  }, [_vm._v("Reset Reconfirmation")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.service.confirmation_attendant))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  }), _vm._v(" " + _vm._s(_vm.service.confirmation_number))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.service.confirmation_datetime))]), _vm._v(" "), ((parseInt(_vm.$store.state.config.user.level) < 4)) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" " + _vm._s(parseInt(_vm.service.confirmation_payment) == 1 ? 'Payed' : 'Not Payed'))]) : _vm._e(), _vm._v(" "), ((parseInt(_vm.$store.state.config.user.level) < 4)) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('reconfirm-email', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "reload": _vm.reload
    }
  })], 1) : _vm._e()])])])] : [(parseInt(_vm.$store.state.config.user.level) < 99) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-success"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-success"
  }, [_vm._v("Reconfirmation")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('reconfirm', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "reload": _vm.reload
    }
  })], 1)])])]) : _vm._e()], _vm._v(" "), (parseInt(_vm.$store.state.config.user.level) < 99) ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Internal Tips")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('tips', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "reload": _vm.reloadHistory
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_vm._v("History\n            "), _c('button', {
    staticClass: "button is-success is-small",
    on: {
      "click": function($event) {
        return _vm.loadHistory()
      }
    }
  }, [_vm._v("Load history")])]), _vm._v(" "), (_vm.load_history === 1) ? _c('p', {
    staticClass: "panel-block"
  }, [_c('history', {
    attrs: {
      "service": _vm.service
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), (parseInt(_vm.service.internal_status) == 4) ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Skip Information")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('pre', [_vm._v(_vm._s(_vm.service.skipped_information))])])])])])] : [(parseInt(_vm.service.internal_status) < 3) ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-warning"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-warning"
  }, [_vm._v("Skip")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('skip', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "reload": _vm.reload
    }
  })], 1)])])])] : _vm._e()]] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eaacb70","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/Service.vue
// module id = 1170
// module chunks = 39